import { PostReq } from "./axios.interceptor";

const quickPayService = {
    checkout: (request: any) => {
        return new Promise<any>((resolve: any, reject: any) => {
            PostReq("/api/QuickPayPayment/quick-payment-pay-now", request)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    paymentSuccess:(transactionId:any)=>{
        return new Promise<any>((resolve: any, reject: any) => {
            PostReq(`/api/QuickPayPayment/quick-payment-pay-success/${transactionId}`, {})
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
}

export default quickPayService;